import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { TextField } from "@components/molecules";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
import { NoteFields } from "./types";
export var NotesFormContent = function NotesFormContent(_ref) {
  var formRef = _ref.formRef,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      formId = _ref.formId,
      errors = _ref.errors,
      handleSubmit = _ref.handleSubmit,
      values = _ref.values,
      noteFields = _ref.noteFields;
  var intl = useIntl();
  var basicInputProps = useCallback(function () {
    return {
      onBlur: handleBlur,
      onChange: handleChange
    };
  }, [handleChange, handleBlur]);
  var fieldErrors = {};

  if (errors) {
    errors.forEach(function (_ref2) {
      var field = _ref2.field,
          message = _ref2.message;
      var f = field || "deliveryNote";
      fieldErrors[f] = fieldErrors[f] ? [].concat(_toConsumableArray(fieldErrors[f]), [{
        message: message
      }]) : [{
        message: message
      }];
    });
  }

  return React.createElement(S.NotesForm, {
    id: formId,
    ref: formRef,
    onSubmit: handleSubmit
  }, React.createElement(S.Wrapper, null, React.createElement(S.RowWithTwoCells, {
    className: "notes-cells"
  }, (noteFields === null || noteFields === void 0 ? void 0 : noteFields.includes(NoteFields.deliveryNote)) && React.createElement(TextField, _extends({
    name: NoteFields.deliveryNote,
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Delivery notes, e.g. entry code",
      "id": "@next.components.organisms.NotesForm.NotesFormContent.4254334296"
    }, "id", "@next.components.organisms.NotesForm.NotesFormContent.4254334296")),
    value: values.deliveryNote,
    errors: fieldErrors.deliveryNote
  }, basicInputProps())), (noteFields === null || noteFields === void 0 ? void 0 : noteFields.includes(NoteFields.note)) && React.createElement(TextField, _extends({
    name: NoteFields.note,
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Order notes, e.g. terms of production",
      "id": "@next.components.organisms.NotesForm.NotesFormContent.3681887296"
    }, "id", "@next.components.organisms.NotesForm.NotesFormContent.3681887296")),
    value: values.note,
    errors: fieldErrors.note
  }, basicInputProps())))));
};